"use client";

import { Search, TicketPercent, Zap } from "lucide-react";
import { useTranslations } from "next-intl";
import React from "react";

const ICONS_MAP = {
  search: <Search className="text-sleap-gray-950 dark:text-sleap-gray-950" />,
  ticket: (
    <TicketPercent className="text-sleap-gray-950 dark:text-sleap-gray-950" />
  ),
  zap: <Zap className="text-sleap-gray-950 dark:text-sleap-gray-950" />,
};

const BG_CLASSES = [
  "bg-sleap-purple-50 dark:bg-sleap-purple-50",
  "bg-sleap-black-50 dark:bg-sleap-black-50",
  "bg-sleap-light-blue-50 dark:bg-sleap-light-blue-50",
];

const HowWorksSection = () => {
  const t = useTranslations("HomePageHowWorksSection");
  const steps = t.raw("steps");

  return (
    <section className="w-full py-8 px-4 bg-white dark:bg-dark text-sleap-gray-950 dark:text-white rounded-xl m-0 md:py-16">
      <div className="w-full max-w-6xl mx-auto">
        <h2 className="mb-14 text-center font-inter text-3xl font-semibold">
          {t("title")}
        </h2>

        <ul className="flex flex-col gap-6 md:flex-row md:gap-8">
          {steps?.map((step: any, index: number) => (
            <li key={index}>
              <div
                className={`p-6 pb-9 ${BG_CLASSES[index]} rounded-xl shadow-rooms-card`}
              >
                <span className="w-14 h-14 bg-white dark:bg-white rounded-full flex justify-center mb-11 items-center">
                  {ICONS_MAP[step.icon as keyof typeof ICONS_MAP]}
                </span>
                <h3
                  className={`font-inter text-2xl font-semibold mb-4 ${
                    index === 1 ? "text-white" : "text-sleap-gray-950"
                  }`}
                >
                  {step.title}
                </h3>
                <p
                  className={`font-inter text-sm ${
                    index === 1
                      ? "text-white"
                      : "text-sleap-gray-600 dark:text-sleap-gray-600"
                  }`}
                >
                  {step.description}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HowWorksSection;
